import { Action } from '@ngrx/store';

/**
 * Acciones del feature `mobile-branding`.
 *
 * Estas viven exclusivamente en el bundle mobile. El módulo compartido
 * `account.effects` solo dispatcha `BrandingFadeOutRequested` (definida
 * en `core/store/core.actions.ts` como bridge neutro). Cualquier acción
 * de este archivo NO debe ser importada desde código compartido.
 */
export enum MobileBrandingActionsTypes {
  BrandSwapRequested = '[Mobile Branding] Brand Swap Requested',
}

/**
 * Solicita que el swap del launcher icon y la persistencia del brand
 * code ejecuten. La dispara `mobile-branding.effects.ts` cuando llega
 * `AccountLoaded` con afiliaciones que matcheen el registry.
 */
export class BrandSwapRequested implements Action {
  readonly type = MobileBrandingActionsTypes.BrandSwapRequested;

  constructor(public payload: { brandCode: string }) {}
}

export type MobileBrandingActions = BrandSwapRequested;
